import type { IntlShape } from 'react-intl'
import type { ReportListItem } from './types'

export const reportItems: ReportListItem[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Laskuluettelo',
				description: 'Invoice list title',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Laskuluettelo-raportti on nimensä mukaisesti yksinkertainen listaus laskuista.',
				description: 'Invoice list description',
			}),
		key: 'invoiceList',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Laskuluettelo asiakkaittain',
				description: 'Invoice list by customer title',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Laskuluettelo asiakkaittain -raportti näyttää laskut ryhmiteltynä asiakkaittain.',
				description: 'Invoice list by customer description',
			}),
		key: 'invoiceListByCustomer',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Keskeneräiset laskut',
				description: 'Incomplete invoices title',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Keskeneräiset laskut -raportti listaa keskeneräiset laskut.',
				description: 'Incomplete invoices description',
			}),
		key: 'incompleteInvoices',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Avoimet laskut',
				description: 'Open invoices title',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Avoimet laskut -raportti listaa laskut, jotka ovat hyväksytty, mutta niitä ei ole vielä maksettu.',
				description: 'Open invoices description',
			}),
		key: 'openInvoices',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Erääntyneet laskut',
				description: 'Overdue invoices title',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Erääntyneet laskut -raportti listaa laskut, jotka ovat erääntyneet, mutta niitä ei ole vielä maksettu.',
				description: 'Overdue invoices description',
			}),
		key: 'overdueInvoices',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Suoritusluettelo',
				description: 'Payment list title',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Suoritukset-raportti listaa suoritukset ja laskut joihin suoritukset kuuluvat.',
				description: 'Payment list description',
			}),
		key: 'paymentList',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Suoritusten seuranta asiakkaittain',
				description: 'Payment tracking by customer title',
			}),

		key: 'paymentTrackingByCustomer',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Myyntierittely',
				description: 'Sales breakdown title',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Myyntierittely-raportti erittelee laskujen rivitiedot alv-kannoittain. Raportista voi valita joko eritellyn version tai yhteenvedon.',
				description: 'Sales breakdown description',
			}),
		key: 'salesBreakdown',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kateraportti',
				description: 'Margin report title',
			}),

		key: 'marginReport',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Vienti-ilmoitus tullille',
				description: 'Customs export declaration title',
			}),

		key: 'customsExportDeclaration',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tuotteiden myyntitilasto',
				description: 'Product sales statistics title',
			}),

		key: 'productSalesStatistics',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tuotetilasto asiakkaittain',
				description: 'Product stats by customer title',
			}),

		key: 'productStatsByCustomer',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Suoritusten tiliöinti',
				description: 'Payment account breakdown title',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Suoritusten tiliöinti -raportti erittelee tositteiden suoritukset tileittäin.',
				description: 'Payment account breakdown description',
			}),
		key: 'paymentAccountBreakdown',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tiliöintiyhteenveto, suoritukset',
				description: 'Account summary for payments title',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Tiliöintiyhteenveto, suoritukset -raportti tekee yhteenvedon suorituksissa käytetyistä tileistä.',
				description: 'Account summary for payments description',
			}),
		key: 'accountSummaryPayments',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Myynnin tiliöinti',
				description: 'Sales account breakdown title',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Myynnin tiliöinti -raportti erittelee myyntisi tilit laskuittain.',
				description: 'Sales account breakdown description',
			}),
		key: 'salesAccountBreakdown',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tiliöintiyhteenveto, myynti',
				description: 'Sales account summary title',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Tiliöintiyhteenveto, myynti -raportti tekee yhteenvedon myynnissä käytetyistä tileistä.',
				description: 'Sales account summary description',
			}),
		key: 'salesAccountSummary',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Avoimet laskut asiakkaittain',
				description: 'Open invoices by customer title',
			}),

		key: 'openInvoicesByCustomer',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Erääntyneet laskut asiakkaittain',
				description: 'Overdue invoices by customer title',
			}),

		key: 'overdueInvoicesByCustomer',
		icon: 'description',
	},
]
